module.exports = __webpack_public_path__ + "media/images/gold-trophy-e0ec12d34c7f1a0b0011b0f5d8bc6ab6.svg";